export default __webpack_public_path__ + "static/media/npm-square-red-1.d8917a42.svg";